/**
 * Collectionページの弾検索（大分類・小分類プルダウン）
 *
 * 2026-08-22 全面改訂
 *  - 分類データを手書きJSON（コレクション説明欄）から自動生成に移行した。
 *  - 説明欄に旧データが残っているコレクションでは、説明欄の中にも
 *    同じ id="selectbox1" を持つフォームが描画されるため、ページ内に
 *    フォームが2つ存在しうる。getElementById は先頭（＝旧フォーム）を
 *    返してしまうので、**IDではなくフォーム要素を基点に**要素を引く。
 *    旧フォームはDOMから取り除き、二重表示を防ぐ。
 *
 * データの優先順位:
 *  1. メタフィールド custom.category_tree（<script id="ny-category-tree">）
 *  2. テーマアセット ny-trees-<0〜9>.json（data-tree-url + data-collection-id）
 *  3. 旧方式 selectboxData（移行用。マスターに無いコレクションのため残す）
 */

(function () {
  'use strict';

  var jsonObject = null;
  var form = null;
  var select1 = null;
  var select2 = null;
  var button = null;

  // ------------------------------------
  // 共通関数
  // ------------------------------------

  function addOption(selectboxObj, label, val, selected) {
    var option = document.createElement('option');
    option.text = label;
    option.value = val;
    option.selected = selected === true;
    selectboxObj.appendChild(option);
  }

  function deleteAllSelectboxOption(selectboxObj) {
    while (selectboxObj.lastChild) {
      selectboxObj.removeChild(selectboxObj.lastChild);
    }
  }

  // コレクションのURLから、付与されているタグを配列で取得する
  // 例 /collections/collection_name/tag1+tag2 => ['tag1', 'tag2']
  //
  // 注意: Shopifyはタグの並びを文字コード順に並べ替えて出力するため、
  //       「1つ目が大分類・2つ目が小分類」という前提を置いてはいけない。
  function getUrlTagList() {
    var parts = location.pathname.split('/collections/');
    if (parts.length < 2) return [];

    var segments = parts[1].split('/');
    if (segments.length < 2 || segments[1] === '') return [];

    return segments[1].split('+').map(function (t) {
      try {
        return decodeURIComponent(t);
      } catch (e) {
        return t;
      }
    });
  }

  // URL上のタグ配列を、大分類タグ・小分類タグに振り分ける
  function resolveTags() {
    var list = getUrlTagList();
    var result = { tag1: '', tag2: '' };
    if (list.length === 0) return result;

    var i, j, c1;

    // まず大分類が一致するものを探し、その配下で小分類を探す
    for (i = 0; i < jsonObject.length; i++) {
      c1 = jsonObject[i];
      if (list.indexOf(c1.tag) !== -1) {
        result.tag1 = c1.tag;
        for (j = 0; j < c1.list.length; j++) {
          if (list.indexOf(c1.list[j].tag) !== -1) {
            result.tag2 = c1.list[j].tag;
            break;
          }
        }
        return result;
      }
    }

    // 大分類が無く小分類だけURLに付いている場合は、親を逆引きする
    for (i = 0; i < jsonObject.length; i++) {
      c1 = jsonObject[i];
      for (j = 0; j < c1.list.length; j++) {
        if (list.indexOf(c1.list[j].tag) !== -1) {
          result.tag1 = c1.tag;
          result.tag2 = c1.list[j].tag;
          return result;
        }
      }
    }

    return result;
  }

  // ------------------------------------
  // イベント処理
  // ------------------------------------

  function reloadCategory2Options(selectedTag) {
    var tag1 = select1.value;

    deleteAllSelectboxOption(select2);
    addOption(select2, '小分類 - すべて', '');

    for (var i = 0; i < jsonObject.length; i++) {
      var c1 = jsonObject[i];
      if (c1.tag === tag1) {
        for (var j = 0; j < c1.list.length; j++) {
          addOption(select2, c1.list[j].label, c1.list[j].tag, selectedTag === c1.list[j].tag);
        }
        break;
      }
    }
  }

  // URLにタグが指定されている場合は、その値を選択状態にする
  function resetCategorySelectbox() {
    var tags = resolveTags();

    deleteAllSelectboxOption(select1);
    addOption(select1, '大分類 - すべて', '');
    for (var i = 0; i < jsonObject.length; i++) {
      var c1 = jsonObject[i];
      addOption(select1, c1.label, c1.tag, tags.tag1 === c1.tag);
    }

    deleteAllSelectboxOption(select2);
    reloadCategory2Options(tags.tag2);
  }

  // 選択されているタグを付与して、コレクションページをリロードする
  function reloadCollectionPage() {
    var tag1 = select1.value;
    var tag2 = select2.value;

    var urlStrs = location.pathname.split('/');
    var newUrlStrs = [];
    var before = '';

    for (var i = 0; i < urlStrs.length; i++) {
      newUrlStrs.push(urlStrs[i]);
      if (before === 'collections') break;
      before = urlStrs[i];
    }

    var tags = [];
    if (tag1 !== '') tags.push(tag1);
    if (tag2 !== '') tags.push(tag2);
    if (tags.length !== 0) newUrlStrs.push(tags.join('+'));

    window.location.href = newUrlStrs.join('/');
  }

  // ------------------------------------
  // 初期化
  // ------------------------------------

  function start() {
    select1.addEventListener('change', function () {
      reloadCategory2Options('');
    });
    button.addEventListener('click', reloadCollectionPage);

    resetCategorySelectbox();
    form.removeAttribute('hidden');
  }

  function useData(raw) {
    var parsed;
    try {
      parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
    } catch (e) {
      return false;
    }
    if (!Array.isArray(parsed) || parsed.length === 0) return false;
    jsonObject = parsed;
    start();
    return true;
  }

  // 3) 旧方式（コレクション説明欄の selectboxData）
  function useLegacy() {
    if (typeof selectboxData !== 'undefined') useData(selectboxData);
  }

  // 使用するフォームを1つに決め、残り（説明欄に埋まった旧フォーム）を取り除く。
  // 旧フォームを消さないと、同じidの要素が2つ並んで二重表示になる。
  function pickForm() {
    var all = document.querySelectorAll('.ny-collection-form');
    if (all.length === 0) return null;

    var chosen = document.querySelector('.ny-collection-form[data-tree-url]') || all[0];
    for (var i = 0; i < all.length; i++) {
      if (all[i] !== chosen && all[i].parentNode) {
        all[i].parentNode.removeChild(all[i]);
      }
    }

    select1 = chosen.querySelector('#selectbox1, select');
    select2 = chosen.querySelectorAll('select')[1];
    button = chosen.querySelector('#searchButton, button');
    if (!select1 || !select2 || !button) return null;
    return chosen;
  }

  function init() {
    form = pickForm();
    if (!form) return;

    // 1) メタフィールド
    var node = document.getElementById('ny-category-tree');
    if (node && node.textContent.trim() !== '' && useData(node.textContent)) return;

    // 2) テーマアセット（旧方式より必ず先に見る）
    var url = form.getAttribute('data-tree-url');
    var cid = form.getAttribute('data-collection-id');
    if (!url || !cid) {
      useLegacy();
      return;
    }
    fetch(url, { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (all) {
        if (!(all && all[cid] && useData(all[cid]))) useLegacy();
      })
      .catch(useLegacy);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
